export const getTimestampNumbers = (value) => {
    // using seconds
    if (value < 0) {
        return ['0', '0', ':', '0', '0'];
    }
    const date = new Date(value * 1000);
    let timeValue = date.toISOString().substr(11, 8);
    if (timeValue.substring(0, 2) === '00') {
        timeValue = timeValue.substr(3);
    }
    return timeValue.match(/\S/gim) || [];
};
